import http from "@/http/aisea/axios";
const resource = "/enterprises/operations";

export default {
  /**
   * APIでoperationのレポート一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {Object} data - データ
   * @property {OperationReportRootList[]} data.ao_enterprise_vessel_reports - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  index(params = {}) {
    return http.get(`${resource}/reports`, { params });
  },

  /**
   * APIでoperationのレポートを取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {AoEnterpriseVesselReport} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  show(
    aoEnterpriseId, // string
    reportId, // string
    params = {}
  ) {
    return http.get(`${resource}/${aoEnterpriseId}/reports/${reportId}`, {
      params,
    });
  },

  /**
   * Deletes a report.
   *
   * @param {string} aoEnterpriseId - The ID of the enterprise.
   * @param {string} reportId - The ID of the report to delete.
   * @param {Object} [params={}] - Additional parameters for the request.
   * @returns {Promise} A promise that resolves with the response data.
   * @throws {Error}
   */
  delete(
    aoEnterpriseId, // string
    reportId, // string
    params = {}
  ) {
    return http.delete(`${resource}/${aoEnterpriseId}/reports/${reportId}`, {
      params,
    });
  },

  /**
   * Performs a transaction for an operation report.
   *
   * @param {string} aoEnterpriseId - The ID of the AO enterprise.
   * @param {string} reportId - The ID of the report.
   * @param {string} transactionId - The ID of the transaction.
   * @param {Object} body - The transaction body, containing the version number.
   * @returns {Promise} - A promise that resolves to the result of the transaction.
   * @throws {Error}
   */
  transaction(
    aoEnterpriseId, // string
    reportId, // string
    transactionId, // string
    body // {version: number}
  ) {
    return http.post(
      `${resource}/${aoEnterpriseId}/reports/${reportId}/transaction/${transactionId}`,
      body
    );
  },

  /**
   * APIでoperationのレポートcsvをダウンロードする
   * @param {string} aoEnterpriseId - The ID of the AO enterprise.
   * @returns {Promise<Object>}
   * @throws {Error}
   */
  downloadCsv(aoEnterpriseId) {
    return http.get(`${resource}/${aoEnterpriseId}/reports/csv`, {
      responseType: "blob",
    });
  },

  /**
   * Updates an operation report.
   *
   * @param {string} aoEnterpriseId - The ID of the enterprise associated with the operation report.
   * @param {string} reportId - The ID of the operation report to update.
   * @param {Object} [body={}] - The updated data for the operation report.
   * @returns {Promise} - A promise that resolves to the updated operation report.
   * @throws {Error}
   */
  update(
    aoEnterpriseId, // string
    reportId, // string
    body = {
      //   "ao_enterprise_vessel_report_form_versions": [
      //     {
      //       "ao_enterprise_vessel_report_form_version_items": [
      //         {
      //           "form_version_item_id": "string",
      //           "nullable_checked": true,
      //           "value_date": "string",
      //           "value_date_time": "2024-04-18T05:00:21.564Z",
      //           "value_files": [
      //             {
      //               "name": "string"
      //             }
      //           ],
      //           "value_number": 0,
      //           "value_string": "string",
      //           "value_time": "string"
      //         }
      //       ],
      //       "form_version_id": "string"
      //     }
      //   ],
      //   "version": 0
    }
  ) {
    return http.put(`${resource}/${aoEnterpriseId}/reports/${reportId}`, body);
  },

  uploadTempFiles(
    aoEnterpriseId, // string
    hash, // string
    formData // file data
  ) {
    return http.put(`${resource}/${aoEnterpriseId}/reports/files`, formData, {
      params: {
        hash,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /**
   * APIで特定のCSVファイルをダウンロードする
   * @param {string} aoEnterpriseId - The ID of the AO enterprise.
   * @param {string} reportId - The ID of the report.
   * @param {string} aoEnterpriseCsvId - The ID of the CSV file to download.
   * @returns {Promise<Object>}
   * @throws {Error}
   */
  downloadFile(aoEnterpriseId, reportId, aoEnterpriseCsvId) {
    return http.get(
      `${resource}/${aoEnterpriseId}/reports/${reportId}/files/${aoEnterpriseCsvId}`,
      {
        responseType: "blob",
      }
    );
  },
};
